/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

const ROUTING = {
  "analytics": "/analytics",
  "boot": "/",
  "collections": "/collections",
  "dev": {
    "home": "/",
    "items": "/items",
    "root": "/dev"
  },
  "download": "/download",
  "edit": {
    "analytics": "/analytics",
    "items": "/items",
    "collections": "/collections",
    "customization": "/customization",
    "developers": "/developers",
    "home": "/",
    "mapProperties": "/map",
    "qrcodes": "/qr",
    "root": "/edit"
  },
  "gallery": "/gallery",
  "info": {
    "home": "/",
    "inquireWithADeveloper": "/inquire-with-a-developer",
    "inquireWithAnEditor": "/inquire-with-an-editor",
    "questions": "/questions",
    "reportAnIssue": "/report-an-issue",
    "requestAnAccount": "/request-an-account",
    "root": "/info"
  },
  "items": "/items",
  "map": "/map",
  "notFound": "*",
  "qr": {
    "download": "/",
    "root": "/qr"
  }
};
export default ROUTING;
